import React from 'react'
import { Col, Row } from 'antd'
import { CardComponent, ClientlistBarChart, ProfessionalChart } from '../../components'


const Dashboard = () => {
  
  return (
    <div>
      <Row gutter={[16,16]}>
        <Col span={24}>
          <CardComponent />
        </Col>
        <Col span={24}>
          <ProfessionalChart />
        </Col>
        <Col span={24}>
          <ClientlistBarChart />
        </Col>
      </Row>
    </div>
  )
}

export {Dashboard}